import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { percomaticState } from '../../../atoms';
import { sessionCartState } from '../../atoms';
import { getCartFromTrans } from '../../utils/getCartFromTrans';

import { useAppDispatch } from '../../../reduxstore/hooks';
import {
	setCartTotalPlusTax,
	setBalanceDue
} from '../../../domains/Checkout/slice';

export const useUpdateCartItem = (): void => {
	const setSessionCart = useSetRecoilState(sessionCartState);
	const state = useRecoilValue(percomaticState);
	const dispatch = useAppDispatch();

	useEffect(() => {
		// setSaving(true);
		const { currentTrans } = state.ui.homeScreenHandler.orderScreenHandler;

		if (currentTrans) {
			setSessionCart(getCartFromTrans(currentTrans));

			dispatch(setCartTotalPlusTax(currentTrans.total));
			dispatch(setBalanceDue(currentTrans.total));
		}
	}, [dispatch, state, setSessionCart]);
};
